// Exclude the entire UTC anniversary day: a date-only calendar cannot know
// whether a scene has already crossed Planet's two-year billing boundary.
export const getPlanetHdEarliestDate = (now = new Date()) => {
  const anniversary = new Date(Date.UTC(now.getUTCFullYear() - 2, now.getUTCMonth(), now.getUTCDate()))
  // Date.UTC normalizes February 29 in a non-leap target year to March 1;
  // use February 28 before applying the one-day safety margin instead.
  if (anniversary.getUTCMonth() !== now.getUTCMonth()) anniversary.setUTCDate(0)
  anniversary.setUTCDate(anniversary.getUTCDate() + 1)
  return anniversary.toISOString().slice(0, 10)
}

export const isPlanetHdDateAllowed = (value, now = new Date()) => {
  const date = toPlanetHdDateValue(value)
  return Boolean(date && /^\d{4}-\d{2}-\d{2}$/.test(date) && date >= getPlanetHdEarliestDate(now))
}

export const PLANET_HD_EARLIEST_DATE = getPlanetHdEarliestDate()
export const PLANET_HD_EARLIEST_CAMPAIGN_YEAR = Number(PLANET_HD_EARLIEST_DATE.slice(0, 4)) - 1

export const toPlanetHdDateValue = (value) => {
  if (!value) {
    return null
  }

  if (typeof value === 'string') {
    return value.slice(0, 10)
  }

  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return null
  }

  const month = String(value.getMonth() + 1).padStart(2, '0')
  const day = String(value.getDate()).padStart(2, '0')
  return `${value.getFullYear()}-${month}-${day}`
}

export const getPlanetHdAcquisitionRange = ({dateFrom, dateTo} = {}) => ({
  dateFrom: toPlanetHdDateValue(dateFrom) || getPlanetHdEarliestDate(),
  dateTo: toPlanetHdDateValue(dateTo) || toPlanetHdDateValue(new Date()),
})

export const buildPlanetHdAcquisitionQuery = ({
  cloudPercent,
  dateFrom,
  dateTo,
} = {}) => {
  const range = getPlanetHdAcquisitionRange({dateFrom, dateTo})
  const normalizedCloudPercent = Number(cloudPercent)

  return {
    date_from: range.dateFrom,
    date_to: range.dateTo,
    ...(cloudPercent != null && Number.isFinite(normalizedCloudPercent)
      ? {cloud_fraction: Math.min(1, Math.max(0, normalizedCloudPercent / 100))}
      : {}),
  }
}
